import React, { Component } from 'react'
import 'antd/dist/antd.css'
import { Row, Col, Spinner, Alert } from 'reactstrap';
import axios from '../../utils/request';
import EmptyV from '@beisen-phoenix/themed-empty';
import FormEmpty from '@beisen-phoenix/themed-empty/lib/icons/Form';

export class ZhongJiaoReferView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: ""
        }
    };

    componentDidMount() {
        const urlParam = new URLSearchParams(window.location.search);
        let commonParamater = urlParam.get("commonParamater");
        let tenantId = urlParam.get("tenantId");
        let applicantId = urlParam.get("applicantId");
        if (!commonParamater && !applicantId) {
            this.setState({ errorMessage: "参数有误，链接无效！", isLoading: false, isReady: true });
            return;
        }
        this.loadPage(tenantId, commonParamater, applicantId);
    };

    loadPage = (tenantId, commonParamater, applicantId) => {
        let params = {
            tenantId,
            commonParamater,
            applicantId
        };
        axios
            .get("api/ZhongJiao/GetReferEvaluationView", { params: params })
            .then(res => {
                let isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errMessage = null;
                if (!isSuccessValue) {
                    errMessage = res.data.message;
                } else if (resdata !== "") {
                    window.location.href = resdata;
                }
                this.setState({ isLoading: false, isReady: true, errorMessage: errMessage });
            }).catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            });
    };

    render() {
        if (this.state.isReady) {
            return (
                <div style={{ height: '100vh', background: '#fff', margin: '0 -15px', paddingTop: '50px' }}>
                    <div style={{ textAlign: 'center' }}>
                        <EmptyV image={<FormEmpty openChangeSkin={true} />} description={!!this.state.errorMessage ? this.state.errorMessage : "这里什么都没有..."} size={'large'} />
                    </div>
                </div>
            );
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}